var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"a1"},[_vm._v("404页面")]),_c('div',{staticClass:"a2"},[_vm._v(_vm._s(_vm.times)+"s后跳转首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }